<template>
  <div
    v-if="isHexColor"
    :style="hexStyle"
    class="custom-icon"
    :title="name"
  />
  <img
    v-else
    :src="iconSrc"
    :alt="name"
    :width="size"
    :height="size"
    :style="iconStyle"
    class="custom-icon"
  />
</template>

<script>
import ICONS from '@/assets/svg/CustomIcons'

export default {
  name: 'CustomIcon',
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: 24 },
    color: { type: String, default: null }
  },
  computed: {
    iconSrc() {
      const icon = ICONS[this.name] || ICONS['QuestionMark']
      // Manejar módulos ES (si require devuelve un objeto con .default)
      if (typeof icon === 'object' && icon !== null && icon.default) {
        return icon.default
      }
      return icon
    },
    isHexColor() {
      return this.color && this.color.startsWith('#')
    },
    hexStyle() {
      let sizeVal = this.size
      // Si es número o string numérico (ej: "24"), agregar 'px'
      if (typeof sizeVal === 'number' || (typeof sizeVal === 'string' && /^\d+$/.test(sizeVal))) {
        sizeVal = `${sizeVal}px`
      }

      return {
        backgroundColor: this.color,
        '-webkit-mask-image': `url(${this.iconSrc})`,
        'mask-image': `url(${this.iconSrc})`,
        '-webkit-mask-size': 'contain',
        'mask-size': 'contain',
        '-webkit-mask-repeat': 'no-repeat',
        'mask-repeat': 'no-repeat',
        '-webkit-mask-position': 'center',
        'mask-position': 'center',
        width: sizeVal,
        height: sizeVal
      }
    },
    iconStyle() {
      if (!this.color) return {}
      return {
        filter: this.colorToFilter(this.color)
      }
    }
  },
  methods: {
    // Convierte un color a filtro CSS para colorear SVGs
    colorToFilter(color) {
      const colors = {
        'primary': 'invert(29%) sepia(93%) saturate(1352%) hue-rotate(213deg) brightness(93%) contrast(91%)',
        'success': 'invert(48%) sepia(79%) saturate(359%) hue-rotate(93deg) brightness(95%) contrast(92%)',
        'danger': 'invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)',
        'warning': 'invert(77%) sepia(55%) saturate(1025%) hue-rotate(359deg) brightness(103%) contrast(104%)',
        'info': 'invert(68%) sepia(44%) saturate(6063%) hue-rotate(170deg) brightness(97%) contrast(90%)',
        'secondary': 'invert(46%) sepia(8%) saturate(395%) hue-rotate(182deg) brightness(94%) contrast(88%)',
        'white': 'invert(100%) brightness(100%)',
        'black': 'invert(0%) brightness(0%)',
      }
      return colors[color] || null
    }
  }
}
</script>

<style scoped>
.custom-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
